import { lazy, Suspense } from 'react';

import DocumentViewerLoading from './DocumentViewerLoading';
import type { TDocumentViewerBodyProps } from './types';

const DocumentReader = lazy(() => import('@/components/organism/DocumentReader/DocumentReader'));

const FALLBACK = <DocumentViewerLoading />;

const DocumentViewerBody = ({ source, pageRequestId, placeRef }: TDocumentViewerBodyProps) => (
  <Suspense fallback={FALLBACK}>
    <DocumentReader key={source.documentSrc} source={source} pageRequestId={pageRequestId} placeRef={placeRef} />
  </Suspense>
);

export default DocumentViewerBody;
